import { render, staticRenderFns } from "./BookingPlanItem.vue?vue&type=template&id=70ba8ffc&scoped=true&"
import script from "./BookingPlanItem.vue?vue&type=script&lang=js&"
export * from "./BookingPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./BookingPlanItem.vue?vue&type=style&index=0&id=70ba8ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba8ffc",
  null
  
)

export default component.exports